import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=c8640d84&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.vue?vue&type=style&index=0&id=c8640d84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8640d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas_platform_prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8640d84')) {
      api.createRecord('c8640d84', component.options)
    } else {
      api.reload('c8640d84', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=c8640d84&scoped=true", function () {
      api.rerender('c8640d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MicroFrontend/Container.vue"
export default component.exports